import React, { ReactNode } from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { TextBold, TextLink, TextRegular } from "../text"

export type LineLinkProps = {
  linkText: string
  linkIsBeforeText: boolean
  onClickLink: () => {}
}

export type LineProps = {
  text: string
  isTextBold?: boolean
  isTextGrayed?: boolean
  dataCy?: string
  icon?: ReactNode
  className?: string
  link?: LineLinkProps
}

export const Line = (props: LineProps) => {
  const { text, isTextBold = false, isTextGrayed = false, dataCy, icon, className, link } = props

  const renderText = () => {
    if (!link) {
      return isTextBold ? (
        <LineTextBold $isTextGrayed={isTextGrayed} noWrap data-cy={dataCy}>
          <span>{text}</span>
        </LineTextBold>
      ) : (
        <LineTextRegular $isTextGrayed={isTextGrayed} noWrap data-cy={dataCy}>
          <span>{text}</span>
        </LineTextRegular>
      )
    }
    if (link.linkIsBeforeText) {
      return (
        <>
          <TopTextLink noWrap>
            <PrimaryTextBold noWrap onClick={link.onClickLink}>
              {link.linkText}
            </PrimaryTextBold>
          </TopTextLink>
          <TopText $isTextBold={isTextBold}>{`· ${text}`}</TopText>
        </>
      )
    }
    return (
      <>
        <BottomText noWrap>{text}</BottomText>
        <AfterTextLink noWrap onClick={link.onClickLink}>
          <PrimaryTextBold noWrap>{link.linkText}</PrimaryTextBold>
        </AfterTextLink>
      </>
    )
  }

  return (
    <LineDiv className={className}>
      {!!icon && <LineIcon>{icon}</LineIcon>}
      {renderText()}
    </LineDiv>
  )
}

const LineDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.s};
  align-items: center;
  width: 100%;
  overflow: hidden;
`

const LineIcon = styled.div`
  height: ${theme.iconSize.xs};
  width: ${theme.iconSize.xs};

  svg {
    height: ${theme.iconSize.xs};
    width: ${theme.iconSize.xs};
    color: ${theme.color.grey3};
  }
`

const LineTextBold = styled(TextBold)<{ $isTextGrayed: boolean }>`
  color: ${(p) => (p.$isTextGrayed ? theme.color.black4 : "")};
`

const LineTextRegular = styled(TextRegular)<{ $isTextGrayed: boolean }>`
  color: ${(p) => (p.$isTextGrayed ? theme.color.black4 : "")};
`

const TopTextLink = styled(TextLink)`
  min-width: 50px;
  z-index: 10;
`

const PrimaryTextBold = styled(TextBold)`
  color: ${theme.color.primary};
`

const TopText = styled.span<{ $isTextBold: boolean }>`
  color: ${theme.color.black4};
  white-space: nowrap;
  font-weight: ${(p) => (p.$isTextBold ? "bold" : "")};
`

const BottomText = styled(TextRegular)`
  color: ${theme.color.black4};
  min-width: 50px;
`

const AfterTextLink = styled(TextLink)`
  margin-left: ${theme.spacing.s};
  z-index: 10;
`
